import output from "_src/engine/output";
import events from "_src/engine/events";
import GL from "_src/engine/gl";
import extensions from "_src/engine/extensions";

export default {

  isWebGL2 : false,
  mrtEnabled : false,
  floatingTexturesRenderingEnabled: false,
  textureCompressionEnabled: false,

  maxColorAttachments : 1,

  collectSystemData() {

    const mrt_ext = extensions.get("WEBGL_draw_buffers");
    this.mrtEnabled = Boolean(mrt_ext);

    const gl = GL.getContext();

    this.isWebGL2 = GL.checkWebGL2();
    this.maxColorAttachments = getMaxColorBuffers(gl);
    this.floatingTexturesRenderingEnabled = checkFloatingTexturesRendering();
    this.textureCompressionEnabled = checkTextureCompression();

    reportGpuInfo(gl);

  }

}

function checkTextureCompression() {
  const ext =
      extensions.get("WEBGL_compressed_texture_s3tc") ||
      extensions.get("MOZ_WEBGL_compressed_texture_s3tc") ||
      extensions.get("WEBKIT_WEBGL_compressed_texture_s3tc");

  return Boolean(ext);
}

function checkFloatingTexturesRendering() {
  if (GL.checkWebGL2()) {
    if (!extensions.get("EXT_color_buffer_half_float")) {
      return false;
    }
  } else {
    if (!extensions.get("OES_texture_half_float")) {
      return false;
    }
  }

  return true;
}

function getMaxColorBuffers(gl) {
  let maxColorBuffers = 1;

  if (GL.checkWebGL2()) {
    maxColorBuffers = gl.getParameter(gl.MAX_COLOR_ATTACHMENTS);
  } else {
    const ext = extensions.get("WEBGL_draw_buffers");
    if (ext != null) {
      maxColorBuffers = gl.getParameter(ext.MAX_DRAW_BUFFERS_WEBGL);
    }
  }

  return maxColorBuffers;
}

function reportGpuInfo(gl) {
  const debugInfo = extensions.get("WEBGL_debug_renderer_info");
  if (debugInfo !== null) {
    const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
    const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    checkIntelIntegrated(renderer);

    output.log("GPU driver vendor: \"" + vendor + "\"", output.GREEN);
    output.log("GPU driver renderer: \"" + renderer + "\"", output.GREEN);
  }
}

function checkIntelIntegrated(renderer) {
  renderer = renderer.toLowerCase();
  if ((renderer.includes("intel") || renderer.includes("iris")) && !renderer.includes("arc")) {
    events.emit("integratedVideoCardDetected");
  }
}
